// Deps
import { createComponent } from "react-fela";

// import { AnimatePresence } from "framer-motion";
import Head from "~/components/global/head";
import Header from "~/components/global/header";
import Footer from "~/components/global/footer";
import { SiteMaxWidth } from "~/components/layout/max-width";

export default ({ children, className }) => (
    <SiteMaxWidth>
        <SiteWrapper>
            <Head />

            <Header />

            <MainContent className={className} id="main-content">
                {/* <AnimatePresence exitBeforeEnter> */}
                {children}
                {/* </AnimatePresence> */}
            </MainContent>

            <Footer />
        </SiteWrapper>
    </SiteMaxWidth>
);

const SiteWrapper = createComponent(() => ({
    background: "white",
    position: "relative"
}));

const MainContent = createComponent(
    () => ({}),
    "main",
    ["className", "id"]
);
